import React from 'react';
import styled from 'styled-components';
import { theme } from '../../../styles/theme';

export interface LoadingSpinnerProps {
  size?: 'small' | 'medium' | 'large';
  color?: string;
  fullWidth?: boolean;
}

const SpinnerContainer = styled.div<{ $fullWidth: boolean }>`
  display: ${props => props.$fullWidth ? 'flex' : 'inline-flex'};
  align-items: center;
  justify-content: center;
  width: ${props => props.$fullWidth ? '100%' : 'auto'};
`;

const Spinner = styled.div<{ $size: 'small' | 'medium' | 'large'; $color: string }>`
  display: inline-block;
  border-radius: 50%;
  border-top-color: transparent;
  animation: spin 1s ease-in-out infinite;
  
  ${({ $size }) => {
    switch ($size) {
      case 'small':
        return `
          width: 16px;
          height: 16px;
          border-width: 2px;
        `;
      case 'medium':
        return `
          width: 24px;
          height: 24px;
          border-width: 3px;
        `;
      case 'large':
        return `
          width: 32px;
          height: 32px;
          border-width: 4px;
        `;
    }
  }}
  
  border-color: ${props => props.$color};
  border-style: solid;
  
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  size = 'medium',
  color,
  fullWidth = false
}) => {
  const spinnerColor = color || theme.colors.primary;
  
  return (
    <SpinnerContainer $fullWidth={fullWidth}>
      <Spinner $size={size} $color={spinnerColor} />
    </SpinnerContainer>
  );
};

